<template>
  <svg fill="#fff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" d="M0 0h24v24H0Z" />
    <path
      d="M12 6.65v0c1.64 1.28 2.59 3.25 2.59 5.34l-.01-.01c0 2.08-.96 4.05-2.6 5.34l-.01-.01c-1.65-1.29-2.6-3.26-2.6-5.35l-.01-.01c-.01-2.09.95-4.06 2.59-5.35Zm-.87-.59h-.01C9.38 7.54 8.38 9.7 8.39 11.98v-.01c-.01 2.27.99 4.44 2.72 5.92v-.01c-3.28 1.83-7.42.67-9.26-2.61 -1.84-3.28-.68-7.42 2.6-9.26 2.06-1.17 4.59-1.17 6.65 0Zm1.74 11.85v-.01c1.73-1.49 2.73-3.65 2.72-5.93v-.01c0-2.29-1-4.45-2.74-5.93h-.01c3.27-1.84 7.41-.68 9.25 2.59 1.83 3.27.67 7.41-2.6 9.25 -2.07 1.16-4.6 1.16-6.66 0Z"
    />
  </svg>
</template>
